import { Controller } from "@hotwired/stimulus"

/**
 * Grilla tipo agenda: al hacer click en la columna del día, calcula la hora
 * según la posición Y y abre el modal de nuevo timeslot.
 * Usa un enlace programático con data-turbo-frame para mantener el contenido
 * de fondo visible (Turbo.visit con frame puede reemplazar la página en prod).
 */
export default class extends Controller {
  static values = {
    weekday: String,
    newUrl: String,
    rangeStart: String,  // "07:00"
    rangeEnd: String,    // "22:00"
    pixelsPerHour: { type: Number, default: 64 }
  }

  connect() {
    this.element.addEventListener("click", (e) => this.onClick(e))
    this.element.style.cursor = "pointer"
  }

  onClick(event) {
    if (event.target.closest("a, button")) return

    const rect = this.element.getBoundingClientRect()
    const y = event.clientY - rect.top
    const totalHeight = rect.height
    if (totalHeight <= 0) return

    const startTime = this.calculateStartTime(y, totalHeight)
    const url = new URL(this.newUrlValue, window.location.origin)
    url.searchParams.set("start_time", startTime)

    const link = document.createElement("a")
    link.href = url.toString()
    link.dataset.turboFrame = "modal"
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  calculateStartTime(offsetY, totalHeight) {
    const [startH, startM] = this.rangeStartValue.split(":").map(Number)
    const [endH, endM] = this.rangeEndValue.split(":").map(Number)
    const startMinutes = startH * 60 + startM
    const endMinutes = endH * 60 + endM
    const totalMinutes = endMinutes - startMinutes

    const ratio = Math.min(1, Math.max(0, offsetY / totalHeight))
    let minutes = Math.round(startMinutes + ratio * totalMinutes)
    minutes = Math.round(minutes / 15) * 15
    minutes = Math.min(endMinutes - 15, Math.max(startMinutes, minutes))

    const h = Math.floor(minutes / 60) % 24
    const m = minutes % 60
    return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0")
  }
}
